import { OWNER_MANUALS_CATEGORIES_ENDPOINT, OWNER_MANUALS_ENDPOINT } from '@yme/common/endpoints';
import { Filters } from '@yme/common/types';
import { Network } from '@yme/services/network';
const buildEndpoint = (category, defaultEndpoint) => {
    const queryParams = new URLSearchParams();
    if (category)
        queryParams.set(Filters.CATEGORY, category);
    return `${defaultEndpoint}?${queryParams.toString()}`;
};
export async function getOwnerManuals(category) {
    const endpoint = buildEndpoint(category, OWNER_MANUALS_ENDPOINT);
    const response = await Network.get(endpoint);
    return response.data;
}
export async function getOwnerManualsCategories() {
    const response = await Network.get(OWNER_MANUALS_CATEGORIES_ENDPOINT);
    return response.data;
}
